<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-12">
          <div class="element-box" style="padding: 0.2rem 2rem">
            <h5 class="form-header">
              <router-link
                class="btn btn-sm btn-outline-info"
                :to="{ name: 'inventario-tarima_devoluciones' }"
              >
                <i class="fas fa-angle-double-left"></i>
                Atras
              </router-link>
              &nbsp; Devolución #
              <u>{{ current.numero }}</u>
              &nbsp;
              <small>
                &nbsp; Barra: &nbsp;
                <u>{{ current.barra }}</u>
                &nbsp;</small
              >
              &nbsp;
              <div
                class="badge"
                :class="{
                  'badge-success': current.estado == 'A',
                  'badge-danger': current.estado == '9',
                  'badge-primary': current.estado == 'C',
                  'badge-blue': current.estado == 'E',
                  'badge-light': current.estado == 'F',
                  'badge-warning': current.estado == 'G',
                  'badge-dark': current.estado == 'H',
                }"
              >
                <i class="os-icon os-icon-ui-09"></i>
                <span v-if="current.estado_str">{{ current.estado_str }}</span>
              </div>
              <div class="st-meta float-right">
                <div>
                  <span>Tipo:</span>
                  <span
                    class="text-success"
                    v-if="
                      current.salida_traslado_e &&
                      current.salida_traslado_e.tipo_traslado == 'T'
                    "
                  >
                    Traslado
                  </span>
                  <span
                    class="text-danger"
                    v-if="
                      current.salida_traslado_e &&
                      current.salida_traslado_e.tipo_traslado == 'D'
                    "
                  >
                    Tarima Devolucíon
                  </span>
                </div>
                <!-- <div class="element-actions">
                    <button
                      :disabled="current.estado == 'A'"
                      class="btn btn-outline-dark"
                    >
                      <i class="fa fa-print"></i>
                      Imprimir
                    </button>
                    &nbsp;
                    <div class="btn-group">
                      <button
                        :disabled="!current.id"
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="btn btn-secondary dropdown-toggle"
                        data-toggle="dropdown"
                        type="button"
                      >
                        <i class="fa fa-cogs"></i>
                        Acciones
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <button
                          class="dropdown-item"
                          :class="{ disabled: !(current.estado == 'B') }"
                          :disabled="!(current.estado == 'B')"
                          href="#"
                        >
                          <i class="fa fa-unlock"></i>
                          Abrir Operación
                        </button>
                        <button
                          class="dropdown-item"
                          :disabled="!(current.estado == 'A')"
                          href="#"
                        >
                          <i class="fa fa-lock"></i>
                          Cerrar Operación
                        </button>
                        <button
                          class="dropdown-item"
                          :disabled="!(current.estado != '9')"
                          href="#"
                        >
                          <i class="fa fa-archive"></i>
                          Anular Operación
                        </button>
                        <div class="dropdown-divider"></div>
                        <button
                          class="dropdown-item"
                          :disabled="current.estado != 'B'"
                          href="#"
                        >
                          <i class="fa fa-paper-plane"></i>
                          Generar Traslado de Producto
                        </button>
                      </div>
                    </div>
                  </div> -->
              </div>
            </h5>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-7">
          <div class="element-wrapper">
            <div class="element-box">
              <h5 class="form-header">Información General</h5>
              <div class="row">
                <div class="col-sm-3">
                  <div class="form-group">
                    <label for>Tienda origen</label>
                    <div class="input-group">
                      <input
                        disabled
                        v-if="current.tienda_origen_obj"
                        v-model="current.tienda_origen_obj.nombre"
                        class="form-control"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label for>Tienda destino</label>
                    <div class="input-group">
                      <input
                        disabled
                        v-if="current.tienda_destino_obj"
                        v-model="current.tienda_destino_obj.nombre"
                        class="form-control"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label for>Usuario</label>
                    <div class="input-group">
                      <input
                        disabled
                        v-if="current.usuario && current.usuario.username"
                        v-model="current.usuario.username"
                        class="form-control"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label>Posicíon</label>
                    <div class="input-group">
                      <input
                        disabled
                        v-if="current.posicion"
                        v-model="current.posicion.barra"
                        class="form-control"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <router-link
                    target="_blank"
                    v-if="current.salida_traslado_e"
                    class="btn btn-outline-success btn-sm col-12"
                    :to="{
                      name: 'inventario-salida_traslado-editar',
                      params: { id: current.salida_traslado_e.id },
                    }"
                  >
                    Salida traslado
                    <i class="fas fa-eye"></i>
                  </router-link>
                </div>
                <div class="col-6">
                  <router-link
                    target="_blank"
                    v-if="current.entrada_traslado_e"
                    class="btn btn-outline-success btn-sm col-12"
                    :to="{
                      name: 'inventario-entrada_traslado-editar',
                      params: { id: current.entrada_traslado_e },
                    }"
                  >
                    Entrada traslado
                    <i class="fas fa-eye"></i>
                  </router-link>
                </div>
              </div>
              <div class="form-buttons-w">
                <button
                  class="btn btn-md btn-success"
                  v-if="current.id == null"
                  type="submit"
                >
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-5">
          <div class="element-box">
            <h5 class="form-header text-center">Historial de movimientos</h5>
            <div class="row">
              <table
                class="table table-bordered table-striped font-weight-bold"
              >
                <thead>
                  <tr></tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Creación:</td>
                    <td class="text-right text-success">
                      {{
                        current.fecha_creacion | moment("DD/MM/YYYY hh:mm:ss a")
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Inicio de carga</td>
                    <td class="text-right text-success">
                      {{
                        current.fecha_inicio_carga
                          | moment("DD/MM/YYYY hh:mm:ss a")
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Fin de carga:</td>
                    <td class="text-right text-success">
                      {{
                        current.fecha_fin_carga
                          | moment("DD/MM/YYYY hh:mm:ss a")
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Cargado al contenedor:</td>
                    <td class="text-right text-success">
                      {{
                        current.fecha_asignado_ruta
                          | moment("DD/MM/YYYY hh:mm:ss a")
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Recepcionado en tienda:</td>
                    <td class="text-right text-success">
                      {{
                        current.fecha_recepcion_tarima
                          | moment("DD/MM/YYYY hh:mm:ss a")
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Inicio de conteo:</td>
                    <td class="text-right text-success">
                      {{
                        current.inicio_detallado
                          | moment("DD/MM/YYYY hh:mm:ss a")
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Fin de conteo y detallado:</td>
                    <td class="text-right text-success">
                      {{
                        current.fin_detallado | moment("DD/MM/YYYY hh:mm:ss a")
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="element-box">
            <h6 class="form-header">Detalle de Tarima</h6>
            <div
              style="overflow-y: scroll; max-height: 400px"
              class="table-voice"
            >
              <div class="table-responsive" v-if="current.id != null">
                <table class="table table-hover table-striped">
                  <thead>
                    <tr>
                      <th>SKU</th>
                      <th class="text-right" style="width: 10%">Enviada</th>
                      <th class="text-right" style="width: 10%">Ingresada</th>
                      <th class="text-center" style="width: 25%">
                        Intentos de conteo
                      </th>
                      <th class="text-center">Estatus</th>
                      <th class="text-center">Motivo Devolución</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="detalle in current.detalle"
                      v-bind:key="detalle.id"
                      @click="verDetalleLinea(detalle)"
                    >
                      <td>
                        {{ detalle.producto_obj.sku }} -
                        {{ detalle.producto_obj.nombre }}
                      </td>
                      <td
                        v-if="detalle.total_enviada"
                        class="text-right font-weight-bold"
                        style="color: #4bb018"
                      >
                        {{ detalle.total_enviada }}
                      </td>
                      <td
                        v-if="!detalle.total_enviada"
                        class="text-right font-weight-bold"
                        style="color: #241dfb"
                      ></td>
                      <td
                        class="font-weight-bold text-right"
                        v-if="detalle.total_recibida"
                        :class="{
                          'text-success':
                            detalle.total_enviada == detalle.total_recibida,
                          'text-danger':
                            detalle.total_enviada != detalle.total_recibida,
                        }"
                      >
                        {{ detalle.total_recibida }}
                      </td>

                      <td
                        v-if="!detalle.total_recibida"
                        class="text-right font-weight-bold"
                        style="color: #37c21b"
                      ></td>
                      <td
                        v-if="detalle.intentos_conteo_destino"
                        class="text-center font-weight-bold"
                        :class="{
                          'text-success':
                            detalle.intentos_conteo_destino ==
                              detalle.intentos_maximos_destino ||
                            detalle.intentos_conteo_destino <
                              detalle.intentos_maximos_destino,
                          'text-danger':
                            detalle.intentos_conteo_destino >
                            detalle.intentos_maximos_destino,
                        }"
                      >
                        {{ detalle.intentos_conteo_destino }}
                      </td>
                      <td
                        v-if="!detalle.intentos_conteo_destino"
                        class="text-center font-weight-bold"
                        style="color: #e91414"
                      ></td>
                      <td class="text-center">
                        <div
                          class="font-weight-bold"
                          :class="{
                            'status-pill smaller green':
                              detalle.total_enviada == detalle.total_recibida,
                            'status-pill smaller red':
                              detalle.total_enviada != detalle.total_recibida,
                          }"
                        ></div>
                      </td>
                      <td
                        class="text-center"
                        v-if="
                          detalle.tarimaproductod_set &&
                          detalle.tarimaproductod_set[0]
                        "
                      >
                        {{
                          detalle.tarimaproductod_set[0].salida_traslado_d
                            .motivo_devolucion.descripcion
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-------------------- END - Basic Table -------------------->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="onboardingSlideModal"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            @click="hideModal"
            type="button"
          >
            <span class="close-label">Cerrar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-slider-w">
            <div class="onboarding-slide">
              <div class="onboarding-content with-gradient">
                <h4 class="onboarding-title">Detalle de tarima producto</h4>

                <div class="table-voice">
                  <div class="table-responsive" v-if="current.id != null">
                    <table class="table table-hover table-striped">
                      <thead>
                        <tr>
                          <th class="text-left">SKU</th>
                          <th class="text-right" style="width: 10%">Enviada</th>
                          <th class="text-right" style="width: 10%">
                            Ingresada
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="detalle in currentDetalle.tarimaproductod_set"
                          v-bind:key="detalle.id"
                        >
                          <td class="text-left">
                            {{ currentDetalle.producto_obj.sku }} -
                            {{ currentDetalle.producto_obj.nombre }}
                          </td>
                          <td
                            v-if="detalle.cantidad"
                            class="text-right font-weight-bold"
                            style="color: #4bb018"
                          >
                            {{ detalle.cantidad }}
                          </td>
                          <td
                            v-if="!detalle.cantidad"
                            class="text-right font-weight-bold"
                            style="color: #241dfb"
                          ></td>
                          <td
                            class="font-weight-bold text-right"
                            v-if="detalle.recibida"
                            :class="{
                              'text-success':
                                detalle.cantidad == detalle.recibida,
                              'text-danger':
                                detalle.cantidad != detalle.recibida,
                            }"
                          >
                            {{ detalle.recibida }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <!-------------------- END - Basic Table -------------------->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {},
  data() {
    return {
      current: {
        err: "",
        conteo: "",
      },
      currentDetalle: {
        err: "",
      },
      currentDetalle: [],
      detalle_actual: "",
      producto_tienda: "",
      err: [],
    };
  },
  computed: {},
  mounted() {
    let self = this;
    if (this.$route.params.id) {
      self.refreshCurrent(this.$route.params.id);
    }
  },
  methods: {
    hideModal() {
      $("#onboardingSlideModal").modal("hide");
    },
    verDetalleLinea(detalle) {
      let self = this;
      this.currentDetalle = detalle;
      $("#onboardingSlideModal").modal("show");
    },
    refreshCurrent(params) {
      let self = this;
      DynamicService.getById("wms", "tarima", params).then((response) => {
        self.current = response.data;
        self.refreshPosicon();
      });
    },
    refreshPosicon() {
      let self = this;
      DynamicService.getById(
        "cat",
        "tienda-posicion",
        this.current.posicion
      ).then((response) => {
        self.current.posicion = response.data;
      });
    },
  },
};
</script>
